import {useState} from 'react';
import {useAuthedQuery} from '../../../../common/hooks/QueryHooks';

interface NotificationData {
	img_url?: null;
	description?: null;
	read_at?: null;
	created_at?: string;
	id?: string;
	title?: string;
	created_by?: string;
}
interface NotificationTypes {
	data: NotificationData[];
}

const useNotifications = () => {
	const [page] = useState<number>(1);
	const {data, error} = useAuthedQuery<NotificationTypes>(`notifications/enterpriser/all?page=${page}&size=10`);
	return {data, error};
};

export default useNotifications;
